<template>
  <div>
    <MultipleAreaBase
      v-model="inputValue"
      :tables="pageData"
      :title="$t('jd.ship_ship-request-confirm')"
      width="1166px"
      :isFooter="true"
    >
      <template #shipDetail>
        <v-data-table
          :item-class="parentRowClass"
          :headers="headers"
          :items="list"
          hide-default-footer
          :items-per-page="-1"
        >
          <!-- No. -->
          <template v-slot:[`item.index`]="{ item }">
            {{ getIndex(item) + 1 }}
          </template>

          <!-- 店舗名 -->
          <template v-slot:[`item.shopName`]>
            <div class="text-left">
              {{ shopName }}
            </div>
          </template>

          <!-- 依頼商品 -->
          <template v-slot:[`item.jdproductName`]="{ item }">
            <div class="text-left">
              {{ item.exProductName }}
            </div>
          </template>

          <!-- GTIN -->
          <template v-slot:[`item.gtin`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'product.gtinCode' }]"
              :items="getRelatedProductList(item.exProductNumber, platformId)"
              hide-default-header
              hide-default-footer
              :items-per-page="-1"
              no-data-text="-"
            />
          </template>

          <!-- 商品名 -->
          <template v-slot:[`item.productName`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'productName', align: 'end' }]"
              :items="getRelatedProductList(item.exProductNumber, platformId)"
              hide-default-header
              hide-default-footer
              :items-per-page="-1"
              no-data-text="-"
            >
              <template v-slot:[`item.productName`]="{ item }">
                <div class="text-left">
                  {{ item.product.nameJp }}<br />
                  {{ item.product.nameCn }}
                </div>
              </template>
            </v-data-table>
          </template>

          <!-- 数量 -->
          <template v-slot:[`item.calculatedQuantity`]="{ item }">
            <v-data-table
              class="child-table"
              :headers="[{ value: 'quantity', align: 'end' }]"
              :items="getRelatedProductList(item.exProductNumber, platformId)"
              hide-default-header
              hide-default-footer
              :items-per-page="-1"
              no-data-text="-"
            >
              <template v-slot:[`item.quantity`]="{ item }">
                {{ calculatedQuantity(item.exProductNumber, item.quantity) }}
              </template>
            </v-data-table>
          </template>

          <!-- 受取人名 -->
          <template v-slot:[`item.customerName`]="{ item }">
            <div class="text-left">
              {{ item.customerName }}
            </div>
          </template>

          <!-- 受取人情報 -->
          <template v-slot:[`item.customerInfo`]="{ item }">
            <div class="text-left">
              {{ item.customerName }}<br />
              {{ item.customerAddress }}<br />
              {{ item.customerPhoneNumber }}
            </div>
          </template>
        </v-data-table>
      </template>
      <template #footer>
        <v-container fluid>
          <v-row justify="end" class="ma-1">
            <NormalButton
              :text="$t('jd.ship_ship-request-excel-download')"
              width="293px"
              height="50px"
              @click="register"
            />
          </v-row>
        </v-container>
      </template>
    </MultipleAreaBase>
  </div>
</template>

<script>
import MultipleAreaBase from '@/components/layouts/Dialogs/MultipleArea/MultipleAreaBase'
import { NormalButton } from '@/components/items'
import { mapGetters, mapActions } from 'vuex'
import { i18n } from '@/main.js'

export default {
  components: {
    MultipleAreaBase,
    NormalButton
  },
  props: {
    value: { default: { dialog: false } },
    list: { default: [] },
    shopName: { default: '' },
    platformId: { default: '', required: true }
  },
  data: () => ({
    pageData: [
      {
        title: 'jd.ship_ship-request-detail',
        name: 'shipDetail',
        items: [],
        itemKey: ''
      }
    ],
    headers: [
      {
        text: 'No.',
        value: 'index',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('sale.sale_sale-number'),
        value: 'orderNumber',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('jd.jd_jdcom-store-name'),
        value: 'shopName',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('jd.ship_request-product'),
        value: 'jdproductName',
        sortable: false,
        align: 'center'
      },
      {
        text: 'GTIN',
        value: 'gtin',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('common.product_product-name'),
        value: 'productName',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('common.common_product-quantity'),
        value: 'calculatedQuantity',
        sortable: false,
        align: 'center',
        width: '60'
      },
      {
        text: i18n.tc('jd.ship_receiver-name'),
        value: 'customerName',
        sortable: false,
        align: 'center'
      },
      {
        text: i18n.tc('common.input_recipient-info'),
        value: 'customerInfo',
        sortable: false,
        align: 'center'
      }
    ]
  }),
  methods: {
    ...mapActions('Jdproduct', ['getJdproductListFromApi']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapActions('FileStore', ['externalSystemExcelDownload']),
    async register() {
      // ここで保存ボタンを押したときの動作
      const param = this.list.map((ele) => {
        return ele.exCsvFileDetailId
      })
      const fileURL = await this.externalSystemExcelDownload({
        exCsvFileDetailIdList: param
      })
      if (!fileURL) return
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', 'download.xlsx')
      document.body.appendChild(fileLink)
      fileLink.click()
      this.inputValue.dialog = false
    },
    getIndex(item) {
      return this.list.indexOf(item)
    },
    async init() {
      await this.getJdproductListFromApi()
      await this.getSuppliersFromApi()
      this.pageData = [
        {
          title: this.$t('jd.ship_ship-request-detail').replace(
            'JD.com',
            this.shopName
          ),
          name: 'shipDetail',
          items: [],
          itemKey: ''
        }
      ]
    },
    parentRowClass() {
      return 'parent-row'
    },
    calculatedQuantity(exProductNumber, quantity) {
      const foundJdproduct = this.list.find((item) => {
        return item.exProductNumber === exProductNumber
      })
      return foundJdproduct.quantity * quantity
    }
  },
  watch: {
    inputValue: {
      deep: true,
      async handler(newVal) {
        if (!newVal.dialog) return
        this.init()
      }
    }
  },
  computed: {
    ...mapGetters('Jdproduct', [
      'getJdproductListFromState',
      'getRelatedProductList'
    ]),
    ...mapGetters('Supplier', ['getSupplier']),
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}

::v-deep .v-data-table-header {
  background-color: #97c6ea1a;

  th + th {
    border-left: 1px solid #ddd;
  }
}

::v-deep table td + td {
  border-left: 1px solid #ddd;
}

::v-deep .parent-row:nth-of-type(even) {
  background-color: #f6f6f6;
}

// 5~7列目(GTIN、商品名、数量)はpadding: 0
::v-deep table td:nth-child(n + 5):nth-child(-n + 7) {
  padding: 0 !important;
}

::v-deep .v-data-table.child-table {
  background-color: transparent !important;
  pointer-events: none;
}
</style>
